import React, { useState } from "react";
import { Plus, Upload, X } from "lucide-react";
import ImageIcon from "@mui/icons-material/Image";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import Commonmodal from "../../common/Commonmodal";
import toast from "react-hot-toast";
import Uploadmultiplefile from "../../common/Uploadmultplefile";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import formatDate from "../../common/Formatdate";

const VehicleDocuments = ({
  vehicleDocuments,
  getVehicleProfileDocumentsAPI,
  selectedRow,
  systemUserList,
  handleImageOpen,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const documents = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.documents;
  delete documents?.inverted;
  const resourceTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.resourceTypes;

  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    name: "",
    documenttype: "",
    identificationNo: "",
    description: "",
    isActive: "",
    startDate: "",
    endDate: "",
    file: null,
    isReminderSet: null,
  });

  const [uploadedImages, setUploadedImages] = useState(null);

  const handleChange = async (field, value) => {
    if (field !== "file") {
      setForm((prev) => ({ ...prev, [field]: value }));
    } else {
      if (!value) return;
      const res = await Uploadmultiplefile(value, "vehicles", "vehicle");
      const urls = res?.uploaded?.map((u) => u?.Location || u?.url);
      setUploadedImages(urls);
      setForm((prev) => ({
        ...prev,
        file: res?.uploaded || "",
      }));
    }
  };

  const handleSaveDocument = async () => {
    if (
      !form.name ||
      !form.documenttype ||
      !form.identificationNo ||
      !form?.file ||
      !form?.startDate ||
      !form?.endDate
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/api/documents`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          name: form.name,
          identificationNo: form.identificationNo,
          startDate: form.startDate,
          endDate: form.endDate,
          documentType: form.documenttype,
          description: form.description,
          resourceId: selectedRow?.id, // Replace with actual ID
          resourceType: resourceTypes?.inverted?.vehicles, // Replace with actual type
          filePath: form.file[0]?.url, // Assuming single file upload
          fileName: uploadedImages?.key,
          attachments: JSON.stringify(form.file), // For multiple attachments
          isReminderSet:
            form?.isReminderSet === "true"
              ? Boolean(form?.isReminderSet)
              : false,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Document uploaded successfully");
        setForm({
          name: "",
          documenttype: "",
          identificationNo: "",
          description: "",
          isActive: "",
          startDate: "",
          endDate: "",
          file: null,
          isReminderSet: "",
        });
        setUploadedImages(null);
        setOpen(false);
        getVehicleProfileDocumentsAPI(selectedRow?.id);
      } else {
        toast.error(data?.msg || "Upload failed");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      toast.error("Something went wrong");
    }
  };

  const handleReminderClick = async (item, isReminderSet) => {
  // if (!item?.isReminderSet) {
    const confirmEnable = window.confirm("Do you want to enable the reminder?");
    
    if (confirmEnable) {
      try {
      const response = await fetch(`${apiUrl}/api/documents`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id : item?.id,
          isReminderSet: isReminderSet,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Reminder setted successfully");       
        getVehicleProfileDocumentsAPI(selectedRow?.id);
      } else {
        toast.error(data?.msg || "Upload failed");
      }
    } catch (error) {
      console.error("Error Reminder set:", error);
    }
    }
  // } else {
  //   toast.error("Reminder already enabled");
  // }
};

  return (
    <>
      <div className="p-4 space-y-4">
        {/* Table */}
        <div className="overflow-x-auto rounded-lg border">
          <table className="w-full">
            <thead className="bg-slate-50 border-b">
              <tr>
                {[
                  "Document Type",
                  "Document Name",
                  "File Name",
                  "Attachments",
                  "Valid From",
                  "Valid To",
                  "Document Id",
                  "Uploaded On",
                  "Created By",
                  "Reminder",
                ].map((h, i) => (
                  <th
                    key={i}
                    className="text-left py-3 px-4 text-xs font-semibold uppercase text-slate-500"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {vehicleDocuments.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center py-6 text-sm text-slate-500"
                  >
                    No documents uploaded
                  </td>
                </tr>
              ) : (
                vehicleDocuments.map((item, idx) => (
                  <tr
                    key={idx}
                    className="border-b hover:bg-teal-50 transition"
                  >
                    <td className="py-4 px-4">
                      {documents[item?.documentType]}
                    </td>
                    <td className="py-4 px-4">{item?.name}</td>
                    <td className="py-4 px-4 flex items-center gap-3">
                      <button
                        onClick={() => handleImageOpen(item?.filePath)}
                        className="text-blue-600 hover:text-blue-800"
                        title="Preview"
                      >
                        <ImageIcon fontSize="medium" />
                      </button>
                      {/* <span className="text-sm text-gray-800 truncate max-w-[200px]">
                        {item?.fileName}
                      </span> */}
                    </td>
                    <td className="py-4 px-4">
                      {(() => {
                        let attachments = [];

                        try {
                          attachments = JSON.parse(item?.attachments || "[]");
                        } catch (e) {
                          attachments = [];
                        }

                        return attachments.length > 0 ? (
                          <div className="flex gap-2 flex-wrap w-52">
                            {attachments.map((att, index) => (
                              <button
                                key={index}
                                onClick={() => handleImageOpen(att.url)}
                                className="flex items-center gap-2 group"
                              >
                                <img
                                  src={att.url}
                                  alt={`${item.name}-${index}`}
                                  className="h-6 w-8 object-cover rounded border"
                                />
                              </button>
                            ))}
                          </div>
                        ) : (
                          "-"
                        );
                      })()}
                    </td>
                    <td className="py-4 px-4">{formatDate(item?.startDate)}</td>
                    <td className="py-4 px-4">{formatDate(item?.endDate)}</td>
                    <td className="py-4 px-4">{item?.identificationNo}</td>
                    <td className="py-4 px-4">{formatDate(item?.createdAt)}</td>
                    <td className="py-4 px-4">
                      {systemUserList?.filter(
                        (list) => list?.id === item?.createdBy,
                      )[0]?.name || "-"}
                    </td>
                    <td className="py-4 px-4">
                      <NotificationsActiveIcon
                        sx={{
                          color: item?.isReminderSet ? "green" : "red",
                          cursor: "pointer",
                        }}
                        onClick={() => handleReminderClick(item, !item?.isReminderSet)}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        

        {/* Add Document Button */}
        <div className="flex justify-end">
          <button
            onClick={() => setOpen(true)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 transition"
          >
            <Plus size={16} /> Add Document
          </button>
        </div>

        {/* Upload Modal */}
        {open && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
            <div className="bg-white w-full max-w-lg rounded-xl shadow-xl p-6">
              {/* Modal Header */}
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">Upload Document</h3>
                <button onClick={() => setOpen(false)}>
                  <X className="text-slate-500 hover:text-red-500" />
                </button>
              </div>

              {/* Form */}
              <div className="space-y-4">
                <input
                  name="name"
                  placeholder="Document Name"
                  className="w-full border rounded-lg px-4 py-2 text-sm"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
                <select
                  className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                  value={form.documenttype}
                  onChange={(e) => handleChange("documenttype", e.target.value)}
                >
                  <option value="">Select Document Type</option>
                  {Object.entries(documents).map(([key, label]) => (
                    <option key={key} value={key}>
                      {label}
                    </option>
                  ))}
                </select>

                <input
                  name="identificationNo"
                  placeholder="Document ID"
                  className="w-full border rounded-lg px-4 py-2 text-sm"
                  value={form.identificationNo}
                  onChange={(e) =>
                    handleChange("identificationNo", e.target.value)
                  }
                />
                <input
                  name="description"
                  placeholder="Description"
                  className="w-full border rounded-lg px-4 py-2 text-sm"
                  value={form.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                />

                <select
                  className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                  value={form.isReminderSet}
                  onChange={(e) =>
                    handleChange("isReminderSet", e.target.value)
                  }
                >
                  <option value="">Set Reminder</option>
                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>

                <div className="grid grid-cols-2 gap-3">
                  <input
                    type="date"
                    name="startDate"
                    className="border rounded-lg px-4 py-2 text-sm"
                    value={form.startDate}
                    onChange={(e) => handleChange("startDate", e.target.value)}
                  />
                  <input
                    type="date"
                    name="endDate"
                    className="border rounded-lg px-4 py-2 text-sm"
                    value={form.endDate}
                    onChange={(e) => handleChange("endDate", e.target.value)}
                  />
                </div>

                {/* File Upload */}
                <label className="border-2 border-dashed rounded-lg p-4 text-center cursor-pointer hover:bg-slate-50 transition">
                  {uploadedImages ? (
                    <div className="grid grid-cols-3 gap-2">
                      {uploadedImages?.map((src, i) => (
                        <img
                          key={i}
                          src={src}
                          alt="Preview"
                          className="h-24 w-full object-cover rounded"
                        />
                      ))}
                    </div>
                  ) : (
                    <Upload className="mx-auto text-slate-400 mb-1" />
                  )}
                  <p className="text-sm text-slate-600">
                    {form.file ? "File selected" : "Click to upload document"}
                  </p>
                  <input
                    type="file"
                    name="file"
                    className="hidden"
                    multiple
                    onChange={(e) => handleChange("file", e.target.files)}
                  />
                </label>
              </div>

              {/* Actions */}
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setOpen(false)}
                  className="px-4 py-2 border rounded-lg text-sm"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveDocument}
                  className="px-5 py-2 bg-teal-600 text-white rounded-lg text-sm hover:bg-teal-700"
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default VehicleDocuments;
